import satori from "satori"

type Options = {
  courseName?: string
}

export const getCourseVideoPoster = async (
  title: string,
  options?: Options
) => {
  if (typeof Intl === "undefined" || !("Segmenter" in Intl)) {
    return ""
  }

  const fetchFont = async (path: string) => {
    try {
      const response = await fetch(new URL(path, window.location.origin))

      if (!response.ok) return null

      const contentType = response.headers.get("content-type")
      if (!contentType || !contentType.includes("font")) return null

      return await response.arrayBuffer()
    } catch (error) {
      console.error(error)
      return null
    }
  }

  const fontData = await fetchFont("/assets/fonts/Inter-Regular.ttf")
  const fontDataBold = await fetchFont("/assets/fonts/Inter-Bold.ttf")

  if (!fontData || !fontDataBold) {
    return ""
  }

  const width =
    document.querySelector("video")?.getBoundingClientRect().width ?? 0
  const height = width ? (width * 9) / 16 : 0

  const multiplier = (number: number) => {
    if (window.innerWidth < 400) {
      return number * 1
    }
    if (window.innerWidth < 600) {
      return number * 1.5
    }
    if (window.innerWidth < 900) {
      return number * 2
    }
    if (window.innerWidth < 1080) {
      return number * 3
    }
    if (window.innerWidth < 1400) {
      return number * 3
    }
    return number * 4
  }

  const svg = await satori(
    <div
      style={{
        background: "linear-gradient(135deg, #232526 0%, #414345 100%)",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: 22,
        justifyContent: "space-between",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: -multiplier(20),
          right: -multiplier(20),
          width: multiplier(100),
          height: multiplier(100),
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.1)",
          display: "flex",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: -multiplier(30),
          left: -multiplier(30),
          width: multiplier(80),
          height: multiplier(80),
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.08)",
          display: "flex",
        }}
      />

      {/* Header with logo */}
      <div
        style={{
          padding: multiplier(16),
          display: "flex",
          zIndex: 10,
        }}
      >
        <img
          src="https://assets.suraasa.com/logos/v2/mini.png"
          alt="suraasa-icon"
          width={width / 10}
          height={width / 10}
        />
      </div>

      {/* Content area at bottom */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: multiplier(20),
          background:
            "linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent)",
          zIndex: 10,
          gap: multiplier(4),
        }}
      >
        {options?.courseName && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: multiplier(2),
              marginBottom: multiplier(2),
            }}
          >
            <div
              style={{
                width: multiplier(1),
                height: multiplier(3),
                background: "#FFD700",
                borderRadius: multiplier(0.5),
                display: "flex",
              }}
            />
            <p
              style={{
                fontFamily: "Inter",
                fontSize: multiplier(4),
                color: "rgba(255, 255, 255, 0.9)",
                letterSpacing: multiplier(0.3),
                fontWeight: 600,
                textTransform: "uppercase",
                margin: 0,
                padding: 0,
              }}
            >
              {options.courseName}
            </p>
          </div>
        )}

        <p
          style={{
            fontFamily: "Inter",
            fontSize: multiplier(8),
            letterSpacing: multiplier(-0.2),
            fontWeight: 700,
            color: "#FFFFFF",
            margin: 0,
            padding: 0,
            lineHeight: 1.3,
            textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {title}
        </p>
      </div>
    </div>,
    {
      width,
      height,
      fonts: [
        {
          name: "Inter",
          data: fontData,
          weight: 400,
          style: "normal",
        },
        {
          name: "Inter",
          data: fontDataBold,
          weight: 700,
          style: "normal",
        },
      ],
    }
  )

  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}
